/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import dynamicHydrate from '@bluheadless/ui-logic/src/dynamic-hydration/dynamic-hydrate'
import EmptyIcon from '../../icon/empty'

export * from './project-related-icons'
export const AdyenAlipayColoredIcon = dynamicHydrate(() => import('./adyen-alipay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenAlipayColoredIconSvg = dynamicHydrate(
	() => import('./adyen-alipay-colored-icon').then((mod) => mod.AdyenAlipayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenApplepayColoredIcon = dynamicHydrate(() => import('./adyen-applepay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenApplepayColoredIconSvg = dynamicHydrate(
	() => import('./adyen-applepay-colored-icon').then((mod) => mod.AdyenApplepayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferDeColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-de-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferDeColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-de-colored-icon').then((mod) => mod.AdyenBanktransferDeColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferGbColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-gb-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferGbColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-gb-colored-icon').then((mod) => mod.AdyenBanktransferGbColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferIbanColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-iban-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferIbanColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-iban-colored-icon').then((mod) => mod.AdyenBanktransferIbanColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferItColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-it-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferItColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-it-colored-icon').then((mod) => mod.AdyenBanktransferItColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferNlColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-nl-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferNlColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-nl-colored-icon').then((mod) => mod.AdyenBanktransferNlColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferPlColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-pl-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferPlColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-pl-colored-icon').then((mod) => mod.AdyenBanktransferPlColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBanktransferSeColoredIcon = dynamicHydrate(() => import('./adyen-banktransfer-se-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBanktransferSeColoredIconSvg = dynamicHydrate(
	() => import('./adyen-banktransfer-se-colored-icon').then((mod) => mod.AdyenBanktransferSeColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBcmcColoredIcon = dynamicHydrate(() => import('./adyen-bcmc-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBcmcColoredIconSvg = dynamicHydrate(
	() => import('./adyen-bcmc-colored-icon').then((mod) => mod.AdyenBcmcColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenBlikColoredIcon = dynamicHydrate(() => import('./adyen-blik-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenBlikColoredIconSvg = dynamicHydrate(
	() => import('./adyen-blik-colored-icon').then((mod) => mod.AdyenBlikColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc1VisaColoredIcon = dynamicHydrate(() => import('./adyen-cc-1-visa-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc1VisaColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-1-visa-colored-icon').then((mod) => mod.AdyenCc1VisaColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc2McColoredIcon = dynamicHydrate(() => import('./adyen-cc-2-mc-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc2McColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-2-mc-colored-icon').then((mod) => mod.AdyenCc2McColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc3VpayColoredIcon = dynamicHydrate(() => import('./adyen-cc-3-vpay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc3VpayColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-3-vpay-colored-icon').then((mod) => mod.AdyenCc3VpayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc4MaestroColoredIcon = dynamicHydrate(() => import('./adyen-cc-4-maestro-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc4MaestroColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-4-maestro-colored-icon').then((mod) => mod.AdyenCc4MaestroColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc5DinersColoredIcon = dynamicHydrate(() => import('./adyen-cc-5-diners-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc5DinersColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-5-diners-colored-icon').then((mod) => mod.AdyenCc5DinersColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCc6AmexColoredIcon = dynamicHydrate(() => import('./adyen-cc-6-amex-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCc6AmexColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-6-amex-colored-icon').then((mod) => mod.AdyenCc6AmexColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenCcColoredIcon = dynamicHydrate(() => import('./adyen-cc-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenCcColoredIconSvg = dynamicHydrate(
	() => import('./adyen-cc-colored-icon').then((mod) => mod.AdyenCcColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenDirectebankingColoredIcon = dynamicHydrate(() => import('./adyen-directebanking-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenDirectebankingColoredIconSvg = dynamicHydrate(
	() => import('./adyen-directebanking-colored-icon').then((mod) => mod.AdyenDirectebankingColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenDotpayColoredIcon = dynamicHydrate(() => import('./adyen-dotpay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenDotpayColoredIconSvg = dynamicHydrate(
	() => import('./adyen-dotpay-colored-icon').then((mod) => mod.AdyenDotpayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenEbankingFiColoredIcon = dynamicHydrate(() => import('./adyen-ebanking-fi-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenEbankingFiColoredIconSvg = dynamicHydrate(
	() => import('./adyen-ebanking-fi-colored-icon').then((mod) => mod.AdyenEbankingFiColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenGiropayColoredIcon = dynamicHydrate(() => import('./adyen-giropay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenGiropayColoredIconSvg = dynamicHydrate(
	() => import('./adyen-giropay-colored-icon').then((mod) => mod.AdyenGiropayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenIdealColoredIcon = dynamicHydrate(() => import('./adyen-ideal-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenIdealColoredIconSvg = dynamicHydrate(
	() => import('./adyen-ideal-colored-icon').then((mod) => mod.AdyenIdealColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenMultibancoColoredIcon = dynamicHydrate(() => import('./adyen-multibanco-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenMultibancoColoredIconSvg = dynamicHydrate(
	() => import('./adyen-multibanco-colored-icon').then((mod) => mod.AdyenMultibancoColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenPaypalColoredIcon = dynamicHydrate(() => import('./adyen-paypal-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenPaypalColoredIconSvg = dynamicHydrate(
	() => import('./adyen-paypal-colored-icon').then((mod) => mod.AdyenPaypalColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenPaywithgoogleColoredIcon = dynamicHydrate(() => import('./adyen-paywithgoogle-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenPaywithgoogleColoredIconSvg = dynamicHydrate(
	() => import('./adyen-paywithgoogle-colored-icon').then((mod) => mod.AdyenPaywithgoogleColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenPosCloudColoredIcon = dynamicHydrate(() => import('./adyen-pos-cloud-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenPosCloudColoredIconSvg = dynamicHydrate(
	() => import('./adyen-pos-cloud-colored-icon').then((mod) => mod.AdyenPosCloudColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AdyenQiwiwalletColoredIcon = dynamicHydrate(() => import('./adyen-qiwiwallet-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AdyenQiwiwalletColoredIconSvg = dynamicHydrate(
	() => import('./adyen-qiwiwallet-colored-icon').then((mod) => mod.AdyenQiwiwalletColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AmazonPaymentApbColoredIcon = dynamicHydrate(() => import('./amazon-payment-apb-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AmazonPaymentApbColoredIconSvg = dynamicHydrate(
	() => import('./amazon-payment-apb-colored-icon').then((mod) => mod.AmazonPaymentApbColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const AmazonPaymentV2ColoredIcon = dynamicHydrate(() => import('./amazon-payment-v-2-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AmazonPaymentV2ColoredIconSvg = dynamicHydrate(
	() => import('./amazon-payment-v-2-colored-icon').then((mod) => mod.AmazonPaymentV2ColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const BanktransferColoredIcon = dynamicHydrate(() => import('./banktransfer-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BanktransferColoredIconSvg = dynamicHydrate(
	() => import('./banktransfer-colored-icon').then((mod) => mod.BanktransferColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CashondeliveryColoredIcon = dynamicHydrate(() => import('./cashondelivery-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CashondeliveryColoredIconSvg = dynamicHydrate(
	() => import('./cashondelivery-colored-icon').then((mod) => mod.CashondeliveryColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const CheckmoColoredIcon = dynamicHydrate(() => import('./checkmo-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheckmoColoredIconSvg = dynamicHydrate(
	() => import('./checkmo-colored-icon').then((mod) => mod.CheckmoColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const FilobluPaypalColoredIcon = dynamicHydrate(() => import('./filoblu-paypal-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FilobluPaypalColoredIconSvg = dynamicHydrate(
	() => import('./filoblu-paypal-colored-icon').then((mod) => mod.FilobluPaypalColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaDirectBankTransferColoredIcon = dynamicHydrate(
	() => import('./klarna-direct-bank-transfer-colored-icon'),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaDirectBankTransferColoredIconSvg = dynamicHydrate(
	() => import('./klarna-direct-bank-transfer-colored-icon').then((mod) => mod.KlarnaDirectBankTransferColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaDirectDebitColoredIcon = dynamicHydrate(() => import('./klarna-direct-debit-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KlarnaDirectDebitColoredIconSvg = dynamicHydrate(
	() => import('./klarna-direct-debit-colored-icon').then((mod) => mod.KlarnaDirectDebitColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaPayLaterColoredIcon = dynamicHydrate(() => import('./klarna-pay-later-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KlarnaPayLaterColoredIconSvg = dynamicHydrate(
	() => import('./klarna-pay-later-colored-icon').then((mod) => mod.KlarnaPayLaterColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaPayNowColoredIcon = dynamicHydrate(() => import('./klarna-pay-now-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KlarnaPayNowColoredIconSvg = dynamicHydrate(
	() => import('./klarna-pay-now-colored-icon').then((mod) => mod.KlarnaPayNowColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const KlarnaPayOverTimeColoredIcon = dynamicHydrate(() => import('./klarna-pay-over-time-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KlarnaPayOverTimeColoredIconSvg = dynamicHydrate(
	() => import('./klarna-pay-over-time-colored-icon').then((mod) => mod.KlarnaPayOverTimeColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const MspCashondeliveryColoredIcon = dynamicHydrate(() => import('./msp-cashondelivery-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MspCashondeliveryColoredIconSvg = dynamicHydrate(
	() => import('./msp-cashondelivery-colored-icon').then((mod) => mod.MspCashondeliveryColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const SatispayColoredIcon = dynamicHydrate(() => import('./satispay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SatispayColoredIconSvg = dynamicHydrate(
	() => import('./satispay-colored-icon').then((mod) => mod.SatispayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const ScalapayColoredIcon = dynamicHydrate(() => import('./scalapay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ScalapayColoredIconSvg = dynamicHydrate(
	() => import('./scalapay-colored-icon').then((mod) => mod.ScalapayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const XpayColoredIcon = dynamicHydrate(() => import('./xpay-colored-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XpayColoredIconSvg = dynamicHydrate(
	() => import('./xpay-colored-icon').then((mod) => mod.XpayColoredIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
